export function newId() {
    // Structural, not `Crypto`: core is compiled without the DOM lib so it can be
    // imported by the API, the CLI and the browser from the same build.
    const c = globalThis.crypto;
    if (c?.randomUUID)
        return c.randomUUID();
    const b = new Uint8Array(16);
    if (c?.getRandomValues)
        c.getRandomValues(b);
    else
        for (let i = 0; i < 16; i++)
            b[i] = Math.floor(Math.random() * 256);
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    const hex = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
//# sourceMappingURL=id.js.map